{
  "CANNED_MGMT": {
    "HEADER": "Stöðluð svör",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Add canned response",
    "LOADING": "Fetching canned responses...",
    "SEARCH_404": "Það eru engin atriði sem passa við þessa fyrirspurn.",
    "LIST": {
      "404": "Það eru engin stöðluð svör aðgengileg á þessum reikning.",
      "TITLE": "Stjórna stöðluðum svörum",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Short code",
        "CONTENT": "Efnistexti",
        "INBOXES": "Innhólf",
        "ACTIONS": "Aðgerðir"
      },
      "ALL_INBOXES": "Öll innhólf",
      "FILTER": {
        "ALL_INBOXES": "Öll innhólf",
        "NO_INBOX": "Ekkert innhólf",
        "SEARCH_PLACEHOLDER": "Leita í innhólfum"
      }
    },
    "ADD": {
      "TITLE": "Add canned response",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a short code.",
          "ERROR": "Short Code is required."
        },
        "SUBJECT": {
          "LABEL": "Efni (aðeins tölvupóstur)",
          "PLACEHOLDER": "Valfrjálst efni fyrir tölvupóstssvör / nýjar samræður"
        },
        "CONTENT": {
          "LABEL": "Skilaboð",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Viðhengi"
        },
        "INBOXES": {
          "LABEL": "Innhólf",
          "PLACEHOLDER": "Veldu innhólf (valfrjálst, skildu eftir autt fyrir öll innhólf)"
        },
        "SUBMIT": "Senda"
      },
      "API": {
        "SUCCESS_MESSAGE": "Canned response added successfully.",
        "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
      }
    },
    "EDIT": {
      "TITLE": "Edit canned response",
      "CANCEL_BUTTON_TEXT": "Hætta við",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a shortcode.",
          "ERROR": "Short code is required."
        },
        "SUBJECT": {
          "LABEL": "Efni (aðeins tölvupóstur)",
          "PLACEHOLDER": "Valfrjálst efni fyrir tölvupóstssvör / nýjar samræður"
        },
        "CONTENT": {
          "LABEL": "Skilaboð",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Viðhengi"
        },
        "INBOXES": {
          "LABEL": "Innhólf",
          "PLACEHOLDER": "Veldu innhólf (valfrjálst, skildu eftir autt fyrir öll innhólf)"
        },
        "SUBMIT": "Senda"
      },
      "BUTTON_TEXT": "Breyta",
      "API": {
        "SUCCESS_MESSAGE": "Canned response is updated successfully.",
        "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Eyða",
      "API": {
        "SUCCESS_MESSAGE": "Canned response deleted successfully.",
        "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
      },
      "CONFIRM": {
        "TITLE": "Confirm deletion",
        "MESSAGE": "Ertu viss um að þú viljir eyða",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
